var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bannerContainer",staticClass:"sticky-banner",class:{ 'sticky-banner__fixed': _vm.isFixed },style:(!_vm.isFixed && {'transform': ("translateY(-" + _vm.transalateDistance + "px)")})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }